import { searchApi as searchApiUrl } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';

export const searchApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCircles: builder.query({
      query: (params = {}) => ({
        url: searchApiUrl(),
        method: 'POST',
        body: {
          data: { 
            sortBy: params.sortBy || 'name', 
            sortMode: params.sortMode || 'asc',
            ...params
          },
          method: 'filterCircles'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: ['Circles'],
    }),
    fetchUserGroups: builder.query({
      query: ({ userId, sortBy = 'name', sortMode = 'asc' }) => ({
        url: searchApiUrl(),
        method: 'POST',
        body: {
          data: {
            userId,
            sortBy,
            sortMode
          },
          method: 'filterCircles'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: (result, error, { userId }) => [{ type: 'UserGroups', id: userId }],
    }),
    fetchUserCourses: builder.query({
      query: ({ userId, sortBy = 'name', sortMode = 'asc' }) => ({
        url: searchApiUrl(),
        method: 'POST',
        body: {
          data: { userId, sortBy, sortMode },
          method: 'filterCourses'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: (result, error, { userId }) => [{ type: 'UserCourses', id: userId }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchCirclesQuery,
  useFetchUserGroupsQuery,
  useFetchUserCoursesQuery,
} = searchApiSlice; 